export default __webpack_public_path__ + "static/media/gw.2bfb1be1.svg";